document.addEventListener('DOMContentLoaded', function () {
    //Funcionalidad de swiper
    if (typeof Swiper !== 'undefined') {
      const productSlider = new Swiper('.product-recommendation-slider', {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        centeredSlides: true,
        loop: true,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        
      });
    } else {
      console.error('Swiper library not loaded.');
    }

    //----Funciones para carga dinamica de departamentos y ciudades en direccion de facturación----
    const paisSelect = document.getElementById('country-payment');

    const optionPaisSelect = paisSelect.querySelector('option[value="Colombia"]');

    const nuevasProvincias = [
        ["Amazonas", "Amazonas", ["El Encanto", "La Chorrera", "La Pedrera", "La Victoria", "Leticia", "Miriti - Paraná", "Puerto Alegria", "Puerto Arica", "Puerto Nariño", "Puerto Santander", "Tarapacá"]],
        ["Antioquia", "Antioquia", ["Abejorral", "Abriaquí", "Alejandría", "Amaga", "Amalfi", "Andes", "Angelopolis", "Angostura", "Anorí", "Anza", "Apartadó", "Arboletes", "Argelia", "Armenia", "Barbosa", "Belén De Bajira", "Bello", "Belmira", "Betania", "Betulia", "Briceño", "Buriticá", "Caceres", "Caicedo", "Caldas", "Campamento", "Canalete", "Cañasgordas", "Caracolí", "Caramanta", "Carepa", "Carmen De Viboral", "Carolina", "Caucasia", "Certegui", "Chigorodó", "Cisneros", "Ciudad Bolívar", "Cocorná", "Concepción", "Concordia", "Condoto", "Copacabana", "Dabeiba", "Don Matias", "Ebéjico", "El Bagre", "El Carmen De Atrato", "El Litoral Del San Juan", "El Peñol", "Entrerrios", "Envigado", "Fredonia", "Frontino", "Giraldo", "Girardota", "Gómez Plata", "Granada", "Guadalupe", "Guarne", "Guatape", "Heliconia", "Hispania", "Itagui", "Ituango", "Jardín", "Jericó", "La Ceja", "La Estrella", "La Pintada", "La Unión", "Liborina", "Lloró", "Maceo", "Marinilla", "Medellín", "Medio Atrato", "Medio Baudó", "Medio San Juan", "Montebello", "Murindó", "Mutata", "Nariño", "Nechí", "Necoclí", "Nóvita", "Olaya", "Peque", "Peñol", "Pueblorrico", "Puerto Berrio", "Puerto Nare", "Puerto Triunfo", "Quibdó", "Remedios", "Retiro", "Rionegro", "Rio Quito", "Río Frío", "Sabanalarga", "Sabaneta", "Salgar", "San Andrés", "San Carlos", "San Francisco", "San Jerónimo", "San José De La Montaña", "San Juan De Uraba", "San Luis", "San Pedro", "San Pedro De Uraba", "San Rafael", "San Roque", "San Vicente", "Santa Barbara", "Santa Rosa De Osos", "Santafe De Antioquia", "Santo Domingo", "Santuario", "Segovia", "Sipí", "Sonson", "Sopetran", "Tadó", "Támesis", "Tarazá", "Tarso", "Titiribí", "Toledo", "Turbo", "Union Panamericana", "Uramita", "Urrao", "Valdivia", "Valparaiso", "Vegachí", "Venecia", "Vigía Del Fuerte", "Yalí", "Yarumal", "Yolombó", "Yondó", "Zaragoza"]],
        ["Arauca", "Arauca", ["Arauca", "Arauquita", "Cravo Norte", "Fortul", "Puerto Rondón", "Saravena", "Tame"]],
        ["Atlántico", "Atlántico", ["Baranoa", "Barranquilla", "Campo De La Cruz", "Candelaria", "Galapa", "Juan De Acosta", "Luruaco", "Malambo", "Manati", "Palmar De Varela", "Piojó", "Polonuevo", "Ponedera", "Puerto Colombia", "Repelon", "Sabanagrande", "Sabanalarga", "Santa Lucia", "Santo Tomas", "Soledad", "Suan", "Tubara", "Usiacuri"]],
        ["Bogotá, D.C.", "Bogotá", ["Bogota D.C."]],
        ["Bolívar", "Bolívar", ["Achí", "Altos Del Rosario", "Arenal", "Arjona", "Arroyohondo", "Barranco De Loba", "Calamar", "Cantagallo", "Carmen De Bolívar", "Cartagena", "Cicuco", "Clemencia", "Córdoba", "El Guamo", "El Peñon", "Hatillo De Loba", "Magangué", "Mahates", "Margarita", "María La Baja", "Momil", "Mompós", "Montecristo", "Morales", "Pinillos", "Purísima", "Regidor", "Río Viejo", "San Cristobal", "San Estanislao", "San Fernando", "San Jacinto", "San Jacinto Del Cauca", "San Juan Nepomuceno", "San Martin De Loba", "San Pablo", "Santa Catalina", "Santa Rosa De Lima", "Santa Rosa Del Sur", "Simití", "Soplaviento", "Talaigua Nuevo", "Tierralta", "Tiquisio", "Turbaco", "Turbana", "Valencia", "Villanueva", "Zambrano"]],
        ["Boyacá", "Boyacá", ["Aguada", "Almeida", "Aquitania", "Arcabuco", "Belén", "Berbeo", "Betéitiva", "Boavita", "Boyacá", "Briceño", "Buenavista", "Busbanzá", "Caldas", "Campohermoso", "Cerinza", "Chinavita", "Chiquinquirá", "Chiscas", "Chita", "Chitaraque", "Chivatá", "Chivor", "Chíquiza", "Ciénega", "Combita", "Coper", "Corrales", "Covarachía", "Cubará", "Cucaita", "Cuítiva", "Duitama", "El Cocuy", "El Espino", "Firavitoba", "Floresta", "Gachantivá", "Gameza", "Garagoa", "Guacamayas", "Guateque", "Guayatá", "Guicán", "Iza", "Jenesano", "Jericó", "La Capilla", "La Uvita", "La Victoria", "Labranzagrande", "Macanal", "Maripí", "Miraflores", "Mongua", "Monguí", "Moniquirá", "Motavita", "Muzo", "Nobsa", "Nuevo Colón", "Oicatá", "Otanche", "Pachavita", "Paipa", "Pajarito", "Panqueba", "Pauna", "Paya", "Paz De Río", "Pesca", "Pisba", "Puerto Boyaca", "Páez", "Quípama", "Ramiriquí", "Rondón", "Ráquira", "Saboyá", "Samacá", "San Eduardo", "San José De Pare", "San Luis De Gaceno", "San Mateo", "San Miguel De Sema", "San Pablo Borbur", "San Rosa Viterbo", "Santa María", "Santa Sofía", "Santana", "Sativanorte", "Sativasur", "Siachoque", "Soatá", "Socha", "Socotá", "Sogamoso", "Somondoco", "Sora", "Soracá", "Sotaquirá", "Susacón", "Sutamarchán", "Sutatenza", "Sáchica", "Tasco", "Tenza", "Tibaná", "Tibasosa", "Tinjacá", "Tipacoque", "Toca", "Togüí", "Topaipi", "Tota", "Tunj", "Tunja", "Tununguá", "Turmequé", "Tutazá", "Tuta", "Umbita", "Ventaquemada", "Villa De Leyva", "Viracachá", "Zetaquira"]],
        ["Caldas", "Caldas", ["Aguadas", "Anserma", "Aranzazu", "Belalcázar", "Chinchina", "Filadelfia", "La Dorada", "La Merced", "Manizales", "Manzanares", "Marmato", "Marquetalia", "Marulanda", "Neira", "Norcasia", "Palestina", "Pensilvania", "Pácora", "Riosucio", "Risaralda", "Salamina", "Samaná", "San José", "Supía", "Victoria", "Villamaria", "Viterbo"]],
        ["Caquetá", "Caquetá", ["Albania", "Belén De Los Andaquies", "Cartagena Del Chairá", "Currillo", "El Doncello", "El Paujil", "Florencia", "La Montañita", "Milan", "Morelia", "Puerto Rico", "San Jose Del Fragua", "San Vicente Del Caguán", "Solano", "Solita", "Valparaiso"]],
        ["Casanare", "Casanare", ["Aguazul", "Chameza", "Hato Corozal", "La Salina", "Maní", "Monterrey", "Nunchía", "Orocué", "Paz De Ariporo", "Pore", "Recetor", "Sabanalarga", "San Luis De Palenque", "Sácama", "Tauramena", "Trinidad", "Támara", "Villanueva", "Yopal"]],
        ["Cauca", "Cauca", ["Almaguer", "Argelia", "Balboa", "Bolívar", "Buenos Aires", "Cajibío", "Caldono", "Caloto", "Corinto", "El Tambo", "Florencia", "Guapi", "Inzá", "Jambalo", "La Sierra", "La Vega", "Lopez", "Mercaderes", "Miranda", "Morales", "Padilla", "Paez", "Patia", "Piamonte", "Piendamo", "Popayán", "Puerto Tejada", "Purace", "Rosas", "San Sebastian", "Santa Rosa", "Santander De Quilichao", "Silvia", "Sotara", "Suarez", "Sucre", "Timbio", "Timbiqui", "Toribio", "Totoro", "Villa Rica"]],
        ["Cesar", "Cesar", ["Aguachica", "Agustín Codazzi", "Astrea", "Becerril", "Bosconia", "Chimichagua", "Chiriguana", "Curumaní", "El Copey", "El Paso", "Gamarra", "González", "La Gloria", "La Jagua De Ibirico", "La Paz", "Manaure", "Pailitas", "Pelaya", "Pueblo Bello", "Río De Oro", "San Alberto", "San Diego", "San Martín", "Tamalameque", "Valledupar"]],
        ["Chocó", "Chocó", ["Acandí", "Alto Baudó", "Atrato", "Bagadó", "Bahía Solano", "Bajo Baudó", "Bojaya", "Canton De San Pablo", "Carmén Del Darién", "Certegui", "Condoto", "El Carmen De Atrato", "El Litoral Del San Juan", "Itsmina", "Juradó", "Lloró", "Medio Atrato", "Medio Baudó", "Medio San Juan", "Nuquí", "Nóvita", "Quibdó", "Rio Quito", "Riosucio", "Río Frío", "San José Del Palmar", "Sipí", "Tadó", "Unguía", "Union Panamericana"]],
        ["Cundinamarca", "Cundinamarca", ["Agua De Dios", "Albán", "Anapoima", "Anolaima", "Apulo", "Arbeláez", "Beltrán", "Bituima", "Bojacá", "Cabrera", "Cachipay", "Cajicá", "Caparrapí", "Carmen De Carupa", "Caqueza", "Chaguaní", "Chipaque", "Choachí", "Chocontá", "Chía", "Cogua", "Cota", "Cucunubá", "El Colegio", "El Peñón", "El Rosal", "Facatativá", "Fomeque", "Fosca", "Funza", "Fusagasugá", "Fúquene", "Gachala", "Gacheta", "Gachancipá", "Gama", "Girardot", "Granada", "Guacheta", "Guaduas", "Guasca", "Guataquí", "Guatavita", "Guayabal De Siquima", "Guayabetal", "Gutiérrez", "Jerusalén", "Junín", "La Calera", "La Mesa", "La Palma", "La Peña", "La Vega", "Lenguazaque", "Macheta", "Madrid", "Manta", "Medina", "Mosquera", "Nariño", "Nemocon", "Nilo", "Nimaima", "Nocaima", "Pacho", "Paime", "Pandi", "Paratebueno", "Pasca", "Puerto Salgar", "Puli", "Quebradanegra", "Quetame", "Quipile", "Ricaurte", "San Antonio De Tequendama", "San Bernardo", "San Cayetano", "San Francisco", "San Juan De Río Seco", "Sasaima", "Sesquilé", "Sibaté", "Silvania", "Simijaca", "Soacha", "Sopó", "Subachoque", "Suesca", "Supatá", "Susa", "Sutatausa", "Tabio", "Tausa", "Tena", "Tenjo", "Tibirita", "Tibacuy", "Tocaima", "Tocancipá", "Topaipi", "Ubalá", "Ubaque", "Ubate", "Une", "Usaquén", "Venecia", "Vergara", "Vianí", "Villagomez", "Villapinzón", "Villeta", "Viotá", "Yacopí", "Zipacon", "Zipaquirá", "Útica"]],
        ["Córdoba", "Córdoba", ["Ayapel", "Buenavista", "Canalete", "Cereté", "Chimá", "Chinú", "Ciénaga De Oro", "Cotorra", "La Apartada", "Lorica", "Los Córdobas", "Momil", "Montelíbano", "Montería", "Moñitos", "Planeta Rica", "Pueblo Nuevo", "Puerto Escondido", "Puerto Libertador", "Purísima", "Sahagún", "San Andrés Sotavento", "San Antero", "San Bernardo Del Viento", "San Carlos", "San Pelayo", "Tierralta", "Valencia"]],
        ["Guainía", "Guainía", ["Barranco Mina", "Cacahual", "Inírida", "La Guadalupe", "Mapiripan", "Morichal", "Pana Pana", "Puerto Colombia", "San Felipe"]],
        ["Guaviare", "Guaviare", ["Calamar", "El Retorno", "Miraflores", "San José Del Guaviare"]],
        ["Huila", "Huila", ["Acevedo", "Agrado", "Aipe", "Algeciras", "Altamira", "Baraya", "Campoalegre", "Colombia", "Elías", "Garzón", "Gigante", "Guadalupe", "Hobo", "Isnos", "Iquira", "La Argentina", "La Plata", "Neiva", "Nátaga", "Oporapa", "Paicol", "Palermo", "Palestina", "Pital", "Pitalito", "Rivera", "Saladoblanco", "San Agustín", "Santa María", "Suaza", "Tarqui", "Tello", "Teruel", "Tesalia", "Timaná", "Villavieja", "Yaguará"]],
        ["La Guajira", "La Guajira", ["Albania", "Barrancas", "Dibulla", "Distraccion", "El Molino", "Fonseca", "Hatonuevo", "La Jagua Del Pilar", "Maicao", "Manaure", "Riohacha", "San Juan Del Cesar", "Uribia", "Urumita", "Villanueva"]],
        ["Magdalena", "Magdalena", ["Algarrobo", "Aracataca", "Ariguaní", "Cerro San Antonio", "Chibolo", "Chivolo", "Ciénaga", "Concordia", "El Banco", "El Piñon", "El Reten", "Fundacion", "Guamal", "Nueva Granada", "Pedraza", "Pijiño Del Carmen", "Pivijay", "Plato", "Pueblo Viejo", "Remolino", "Sabanas De San Angel", "Salamina", "San Sebastian De Buenavista", "San Zenon", "Santa Ana", "Santa Barbara De Pinto", "Santa Marta", "Sitionuevo", "Tenerife", "Zapayan", "Zona Bananera"]],
        ["Meta", "Meta", ["Acacias", "Barranca De Upia", "Cabuyaro", "Castilla La Nueva", "Cumaral", "El Calvario", "El Castillo", "El Dorado", "Fuente De Oro", "Granada", "Guamal", "La Macarena", "La Uribe", "Lejanías", "Mapiripan", "Mesetas", "Puerto Concordia", "Puerto Gaitán", "Puerto Lleras", "Puerto Lopez", "Puerto Rico", "Restrepo", "San Carlos Guaroa", "San Juan De Arama", "San Juanito", "San Luis De Cubarral", "San Martín", "Villavicencio", "Vista Hermosa"]],
        ["Nariño", "Nariño", ["Alban", "Aldana", "Ancuya", "Arboleda", "Barbacoas", "Belen", "Buesaco", "Chachagui", "Colon", "Consaca", "Contadero", "Cordoba", "Cuaspud", "Cumbal", "Cumbitara", "El Charco", "El Peñol", "El Rosario", "El Tablon De Gomez", "El Tambo", "Francisco Pizarro", "Funes", "Guachucal", "Guaitarilla", "Gualmatan", "Iles", "Imues", "Ipiales", "La Cruz", "La Florida", "La Llanada", "La Tola", "La Union", "Leiva", "Linares", "Los Andes", "Magui", "Mallama", "Mosquera", "Nariño", "Olaya Herrera", "Ospina", "Policarpa", "Potosí", "Providencia", "Puerres", "Pupiales", "Pasto", "Ricaurte", "Roberto Payan", "Samaniego", "San Bernardo", "San Lorenzo", "San Pablo", "San Pedro De Cartago", "Sandoná", "Santa Barbara", "Santa Cruz", "Sapuyes", "Taminango", "Tangua", "Tumaco", "Tuquerres", "Yacuanquer"]],
        ["Norte de Santander", "Norte de Santander", ["Abrego", "Arboledas", "Bochalema", "Bucarasica", "Cáchira", "Cácota", "Chinácota", "Chitagá", "Convención", "Cucutilla", "Cúcuta", "Durania", "El Carmen", "El Tarra", "El Zulia", "Gramalote", "Hacarí", "Herrán", "La Esperanza", "La Playa", "Labateca", "Los Patios", "Lourdes", "Mutiscua", "Ocaña", "Pamplona", "Pamplonita", "Puerto Santander", "Ragonvalia", "Salazar", "San Calixto", "San Cayetano", "Santiago", "Sardinata", "Silos", "Teorama", "Tibú", "Toledo", "Villa Caro", "Villa Del Rosario"]],
        ["Putumayo", "Putumayo", ["Colón", "Mocoa", "Orito", "Puerto Asis", "Puerto Caicedo", "Puerto Guzman", "Puerto Leguizamo", "San Francisco", "San Miguel", "Santiago", "Sibundoy", "Valle Del Guamuez", "Villa Garzon"]],
        ["Quindío", "Quindío", ["Armenia", "Buenavista", "Calarca", "Circasia", "Cordoba", "Filandia", "Genova", "La Tebaida", "Montengro", "Pijao", "Quimbaya", "Salento"]],
        ["Risaralda", "Risaralda", ["Apía", "Balboa", "Belén De Umbría", "Dosquebradas", "Guática", "La Celia", "La Virginia", "Marsella", "Mistrató", "Pereira", "Pueblo Rico", "Quinchia", "Santa Rosa De Cabal", "Santuario"]],
        ["San Andrés, Providencia y Santa Catalina", "Archipiélago de San Andrés, Providencia y Santa Catalina", ["Providencia Y Santa Catalina", "San Andres"]],
        ["Santander", "Santander", ["Aguada", "Albania", "Aratoca", "Barbosa", "Barichara", "Barrancabermeja", "Betulia", "Bolívar", "Bucaramanga", "Cabrera", "California", "Capitanejo", "Carcasí", "Cepitá", "Cerrito", "Charalá", "Charta", "Chima", "Chipatá", "Cimitarra", "Concepción", "Confines", "Contratación", "Coromoro", "Curití", "El Carmen De Chucurí", "El Guacamayo", "El Peñón", "El Playón", "Encino", "Enciso", "Florián", "Floridablanca", "Galán", "Gambita", "Girón", "Guaca", "Guadalupe", "Guapotá", "Guavatá", "Guepsa", "Hato", "Jesús María", "Jordán", "La Belleza", "La Paz", "Landázuri", "Lebríja", "Los Santos", "Macaravita", "Matanza", "Molagavita", "Mogotes", "Málaga", "Ocamonte", "Oiba", "Onzaga", "Palmar", "Palmas Del Socorro", "Pinchote", "Piedecuesta", "Puente Nacional", "Puerto Parra", "Puerto Wilches", "Páramo", "Rionegro", "Sabana De Torres", "San Andrés", "San Benito", "San Gil", "San Joaquín", "San José De Miranda", "San Miguel", "Santa Bárbara", "Santa Helena Del Opón", "Simacota", "Socorro", "Suaita", "Sucre", "Surata", "Tona", "Valle De San José", "Vetas", "Villanueva", "Vélez", "Zapatoca"]],
        ["Sucre", "Sucre", ["Buenavista", "Caimito", "Chalán", "Coloso", "Corozal", "Coveñas", "El Roble", "Galeras", "Guaranda", "La Unión", "Los Palmitos", "Majagual", "Morroa", "Ovejas", "Palmito", "Sahagún", "Sampués", "San Benito Abad", "San Juan Betulia", "San Marcos", "San Onofre", "San Pedro", "Santiago De Tolú", "Sincelejo", "Sincé", "Sucre", "Tolú Viejo"]],
        ["Tolima", "Tolima", ["Alpujarra", "Alvarado", "Ambalema", "Anzoátegui", "Armero", "Ataco", "Cajamarca", "Carmen De Apicalá", "Casabianca", "Chaparral", "Coello", "Coyaima", "Cunday", "Dolores", "Espinal", "Falan", "Flandes", "Fresno", "Guamo", "Herveo", "Honda", "Ibague", "Icononzo", "La Celia", "Lerida", "Libano", "Mariquita", "Melgar", "Murillo", "Natagaima", "Ortega", "Palocabildo", "Piedras", "Planadas", "Prado", "Purificación", "Rioblanco", "Roncesvalles", "Rovira", "Saldaña", "San Antonio", "San Luis", "Santa Isabel", "Suárez", "Valle De San Juan", "Venadillo", "Villahermosa", "Villarrica"]],
        ["Valle del Cauca", "Valle del Cauca", ["Alcala", "Andalucía", "Ansermanuevo", "Argelia", "Bolívar", "Buenaventura", "Buga", "Bugalagrande", "Caicedonia", "Cali", "Calima", "Candelaria", "Cartago", "Dagua", "El Águila", "El Cairo", "El Cerrito", "El Dovio", "Florida", "Ginebra", "Guacarí", "Jamundí", "La Cumbre", "La Unión", "La Victoria", "Obando", "Palmira", "Pradera", "Restrepo", "Riofrio", "Roldanillo", "San Pedro", "Sevilla", "Toro", "Trujillo", "Tuluá", "Ulloa", "Versalles", "Vijes", "Yotoco", "Yumbo", "Zarzal"]],
        ["Vaupés", "Vaupés", ["Caruru", "Mitú", "Pacoa", "Papunahua", "Taraira", "Yavaraté"]],
        ["Vichada", "Vichada", ["Cumaribo", "La Primavera", "Puerto Carreño", "Santa Rosalía"]]
    ];

    const nuevasProvinciasJSON = JSON.stringify(nuevasProvincias);

    if(optionPaisSelect){
        optionPaisSelect.dataset.provinces = nuevasProvinciasJSON;
    }

    const departamentos = JSON.parse(paisSelect.options[paisSelect.selectedIndex].getAttribute('data-provinces') || '[]');

    const departamentoSelect = document.getElementById("province-payment");
    departamentoSelect.innerHTML = '<option value="" disabled selected>Departamento*</option>';

    departamentos.forEach(([nombreCompleto, value, ciudades]) => {
        let option = document.createElement("option");
        option.textContent = nombreCompleto;
        option.value = value;
        option.setAttribute("data-cities", JSON.stringify(ciudades));

        departamentoSelect.appendChild(option);
    });

    const ciudadesSelect = document.getElementById('city-payment');

    departamentoSelect.addEventListener('change', function(){
        let selectedOption = departamentoSelect.options[departamentoSelect.selectedIndex];
        let ciudades = JSON.parse(selectedOption.getAttribute("data-cities"));

        ciudadesSelect.innerHTML = '<option value="" disabled selected>Ciudad*</option>';

        if(selectedOption != ''){
            ciudades.forEach(ciudad => {
                let option = document.createElement('option');
                option.textContent = ciudad;
                option.value = ciudad;

                ciudadesSelect.appendChild(option);
            });
        }else{
            ciudadesSelect.innerHTML = '<option value="" disabled selected>Ciudad*</option>';
        }
        
    })
});

function toggleBillingAddress(checkbox) {
    var checkboxes = document.getElementsByName('billing-option');
    checkboxes.forEach(function(currentCheckbox) {
        if (currentCheckbox !== checkbox) {
            currentCheckbox.checked = false;
        }
    });

    var billingSection = document.querySelector('.billing-section');
 
    var billingInputs = ['firstname-payment', 'lastname-payment', 'email-payment', 'phone-payment', 'doc_id-payment', 'address1-payment', 'province-payment', 'city-payment'];
 
    if (checkbox.id === 'different-billing-address' && checkbox.checked) {
        billingSection.classList.remove('hidden');
        // new Shopify.CountryProvinceSelector("country-payment","province-payment",{hideElement:"address_province_container2"});
 
        for(var id of billingInputs){
            document.getElementById(id).classList.add('required');
        }
 
    } else {
        billingSection.classList.add('hidden');
 
        for(var id of billingInputs){
            document.getElementById(id).classList.remove('required');
        }
    }
}

function openLoginSidebar(){
    document.querySelector('.overlay-login-sidebar-checkout').style.display = 'block';
}

function closeLoginSidebar(){
    document.querySelector('.overlay-login-sidebar-checkout').style.display = 'none';
}

// Eventos para el checkbox de datos personales
window.addEventListener("load", function () {
    const checkboxDatosPersonales = document.getElementById('personal-data');

    if(checkboxDatosPersonales){
        const firstName = document.getElementById('firstname');
        const lastName = document.getElementById('lastname');
        const email = document.getElementById('email');
        const phone = document.getElementById('phone');
        const NIT = document.getElementById('NIT');

        const firstNameEnvio = document.getElementById('firstname-envio');
        const lastNameEnvio = document.getElementById('lastname-envio');
        const emailEnvio = document.getElementById('email-envio');
        const phoneEnvio = document.getElementById('phone-envio');
        const NITEnvio = document.getElementById('doc_id-envio');

        async function obtenerDireccionesDeUsuario(){
            const selectDirecciones = document.getElementById('direcciones-usuario-envio');

            if(checkboxDatosPersonales.checked){
                if(email.value != ""){
                    try{
                        const response = await fetch("https://n6bvw5g5mcbxerodytgfde7n7y0grxdg.lambda-url.us-east-2.on.aws/get_usuario_y_direcciones", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ action: "obtener_direcciones", email: email.value })
                        })
                    
                        if (!response.ok) {
                            const errorText = await response.text();
                            throw new Error(`Error en response: ${response.status} ${response.statusText} - ${errorText}`);
                        }

                        const responseData = await response.json();

                        while (selectDirecciones.options.length > 1) {
                            selectDirecciones.remove(1);
                        }

                        if (responseData.direcciones && Array.isArray(responseData.direcciones)){

                            responseData.direcciones.forEach((direccion, index)=> {
                                let textoOpcion = `${direccion.direccion || ''}`;

                                if (direccion.codigo_postal) {
                                    textoOpcion += ` (Código Postal: ${direccion.codigo_postal})`;
                                }

                                const valorOpcion = index;

                                const opcion = new Option(textoOpcion, valorOpcion);

                                selectDirecciones.add(opcion);

                            });

                            selectDirecciones.dataset.direccionesData = JSON.stringify(responseData.direcciones);

                        }else{
                            console.error("No se recibieron direcciones válidas en la respuesta.");
                        }

                    }catch (error){
                        console.error("Error durante la obtención o procesamiento de direcciones:", error);
                        while (selectDirecciones.options.length > 1) {
                            selectDirecciones.remove(1);
                        }
                    }

                }else{
                    console.error("El email del usuario no puede estar vacío");
                }
            }else{
                console.log("Checkbox desmarcado, limpiando direcciones...");
                while (selectDirecciones.options.length > 1) {
                    selectDirecciones.remove(1);
                }
                // Elimina los datos guardados si se añadieron
                if (selectDirecciones.dataset.direccionesData) {
                    delete selectDirecciones.dataset.direccionesData;
                }
            }
        }

        if(checkboxDatosPersonales.checked){
            firstNameEnvio.value = firstName.value;
            lastNameEnvio.value = lastName.value;
            emailEnvio.value = email.value;
            obtenerDireccionesDeUsuario();
            phoneEnvio.value = phone.value;
            NITEnvio.value = NIT.value;

            firstName.addEventListener('input', function(){
                firstNameEnvio.value = firstName.value;
            });

            lastName.addEventListener('input', function(){
                lastNameEnvio.value = lastName.value;
            });

            email.addEventListener('input', function(){
                emailEnvio.value = email.value;
            });

            email.addEventListener('change', function(){
                obtenerDireccionesDeUsuario();
            });

            phone.addEventListener('input', function(){
                phoneEnvio.value = phone.value;
            });

            NIT.addEventListener('input', function(){
                NITEnvio.value = NIT.value;
            });
        }

        checkboxDatosPersonales.addEventListener('change', function(){
            const valueFirstName = firstName.value;
            const valueLastName = lastName.value;
            const valueEmail = email.value;
            const valuePhone = phone.value;
            const valueNIT = NIT.value;

            if(this.checked){
                firstNameEnvio.value = valueFirstName;
                lastNameEnvio.value = valueLastName;
                emailEnvio.value = valueEmail;
                phoneEnvio.value = valuePhone;
                NITEnvio.value = valueNIT;

                firstName.addEventListener('input', function(){
                    firstNameEnvio.value = firstName.value;
                });
    
                lastName.addEventListener('input', function(){
                    lastNameEnvio.value = lastName.value;
                });
    
                email.addEventListener('input', function(){
                    emailEnvio.value = email.value;
                });

                email.addEventListener('change', function(){
                    obtenerDireccionesDeUsuario();
                });
    
                phone.addEventListener('input', function(){
                    phoneEnvio.value = phone.value;
                });
    
                NIT.addEventListener('input', function(){
                    NITEnvio.value = NIT.value;
                });

            }else{
                document.getElementById('firstname-envio').value = '';
                document.getElementById('lastname-envio').value = '';
                document.getElementById('email-envio').value = '';
                document.getElementById('phone-envio').value = '';
                document.getElementById('doc_id-envio').value = '';
                document.getElementById('direcciones-usuario-envio').value = '';
                document.getElementById('address1-envio').value = '';
                document.getElementById('address2-envio').value = '';
                document.getElementById('country-envio').value = 'Colombia';
                document.getElementById('province-envio').value = '';
                document.getElementById('city-envio').value = '';
                document.getElementById('postal-code-envio').value = '';
            }
        });

        // Funcion para obtener direcciones al hacer click en checkbox datos personales
        checkboxDatosPersonales.addEventListener('change', function(){
            obtenerDireccionesDeUsuario();
        })
    }

});

function ocultarTodosOverlays() {
    document.querySelectorAll(".compra-overlay-container").forEach(overlay => {
        overlay.style.display = "none";
    });

    document.querySelectorAll(".agregar-boton").forEach(btn => {
        btn.style.display = "block";
    });
}

// Add to cart personalizado
window.addEventListener("load", function () {
    const productForms = document.querySelectorAll("form[data-type='add-to-cart-form']");

    productForms.forEach(productForm => {
        if (productForm) {
            productForm.addEventListener('submit', function(evento) {
                evento.preventDefault();

                const submitButton = productForm.querySelector('button[type="submit"]');
                const buttonText = submitButton ? submitButton.querySelector('.t4s-btn-atc_text') : null;
                const loadingSpinner = submitButton ? submitButton.querySelector('.t4s-loading__spinner') : null;

                if (submitButton) submitButton.disabled = true;
                if (buttonText) buttonText.style.display = 'none';
                if (loadingSpinner) loadingSpinner.hidden = false;

                const formData = new FormData(productForm);

                let url = productForm.action;
                if (!url.includes('/cart/add')) { 
                    let shopUrl = window.Shopify?.routes?.root || '/';
                    if (!shopUrl.endsWith('/')) {
                        shopUrl += '/';
                    }
                    url = `${shopUrl}cart/add.js`;
                }

                const method = 'POST';

                fetch(url, {
                    method: method,
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Producto añadido (respuesta AJAX):', data);
                    if (data.status === 'error' || data.message === 'Cart Error') {
                        console.error('Error al añadir al carrito:', data.description);
                    }
                })
                .catch(error => {
                    console.error('Error en la petición fetch o procesando respuesta:', error);
                })
                .finally(() => {
                    console.log('Refrescando la página...');
                    window.location.reload();
                });
            });
        }
    });
});

// Funcion para rellenar campos de direcciones con direccion seleccionada
window.addEventListener("load", function () {
    const selectDirecciones = document.getElementById('direcciones-usuario-envio');

    selectDirecciones.addEventListener('change', function(){
        const todasLasDirecciones = JSON.parse(selectDirecciones.dataset.direccionesData);
        let direccionSeleccionada = selectDirecciones.value;

        if(direccionSeleccionada != ''){
            document.getElementById('address1-envio').value = todasLasDirecciones[direccionSeleccionada].direccion;
            document.getElementById('address2-envio').value = todasLasDirecciones[direccionSeleccionada].apartamento;
            document.getElementById('postal-code-envio').value = todasLasDirecciones[direccionSeleccionada].codigo_postal;
            document.getElementById('country-envio').value = todasLasDirecciones[direccionSeleccionada].pais;
            document.getElementById('province-envio').value = todasLasDirecciones[direccionSeleccionada].departamento;

            const selectDepartamentos = document.getElementById('province-envio');
            const selectCiudades = document.getElementById('city-envio');

            let selectedOption = selectDepartamentos.options[selectDepartamentos.selectedIndex];
            let ciudades = JSON.parse(selectedOption.getAttribute("data-cities"));

            selectCiudades.innerHTML = '<option value="" disabled selected>Ciudad*</option>';

            if(selectedOption != ''){
                ciudades.forEach(ciudad => {
                    let option = document.createElement('option');
                    option.textContent = ciudad;
                    option.value = ciudad;

                    selectCiudades.appendChild(option);
                });
            }else{
                selectCiudades.innerHTML = '<option value="" disabled selected>Ciudad*</option>';
            }

            document.getElementById('city-envio').value = todasLasDirecciones[direccionSeleccionada].ciudad;
        }else{
            document.getElementById('address1-envio').value = "";
            document.getElementById('address2-envio').value = "";
            document.getElementById('postal-code-envio').value = "";
            document.getElementById('country-envio').value = "Colombia";
            document.getElementById('province-envio').value = "";
            document.getElementById('city-envio').value = "";
        }
        
    })
});

// Funcion para añadir departamentos por seleccion de pais
window.addEventListener("load", function () {
    const provinceSelect = document.getElementById("province-envio");

    const colombiaOption = document.querySelector('option[value="Colombia"]');
    if (!colombiaOption) return;

    const provinces = JSON.parse(colombiaOption.getAttribute("data_provinces"));

    provinceSelect.innerHTML = '<option value="" disabled selected>Departamento*</option>';

    provinces.forEach(([nombreCompleto, value, ciudades]) => {
        let option = document.createElement("option");
        option.textContent = nombreCompleto;
        option.value = value;
        option.setAttribute("data-cities", JSON.stringify(ciudades));

        provinceSelect.appendChild(option);
    });
});

// Mostrar ciudades por departamento seleccionado
window.addEventListener("load", function () {
    const selectDepartamentos = document.getElementById('province-envio');
    const selectCiudades = document.getElementById('city-envio');

    selectDepartamentos.addEventListener('change', function(){
        let selectedOption = selectDepartamentos.options[selectDepartamentos.selectedIndex];
        let ciudades = JSON.parse(selectedOption.getAttribute("data-cities"));

        selectCiudades.innerHTML = '<option value="" disabled selected>Ciudad*</option>';

        if(selectedOption != ''){
            ciudades.forEach(ciudad => {
                let option = document.createElement('option');
                option.textContent = ciudad;
                option.value = ciudad;

                selectCiudades.appendChild(option);
            });
        }else{
            selectCiudades.innerHTML = '<option value="" disabled selected>Ciudad*</option>';
        }
        
    })
});

